export const ItemTypes = {
    USER: 'user',
};
